import { Typography } from 'antd';
import { noop } from 'lodash';
import React, { useState } from 'react';
import AppSearchInput from './AppSearchInput';
import { useModalState } from '../hooks/useModalState';
import GuarantySearchModal from './GuarantySearch';

export type GuarantySelectedType = {
  guarid?: number;
  guarreference?: string;
  guarantorname?: string;
};

export type GuarantySelectProps = {
  onChange?: any;
  value?: GuarantySelectedType;
  phase?: string;
  onlyGuarid?: boolean;
};

const GuarantySelect = ({
  onChange = noop,
  value,
  phase,
  onlyGuarid,
}: GuarantySelectProps) => {
  const [Params, setParams] = useState<GuarantySelectedType>({
    guarid: value?.guarid,
    guarreference: value?.guarreference,
    guarantorname: value?.guarantorname,
  });

  const { visible, close, open } = useModalState(false);
  const handleSelect = (item: any) => {
    onlyGuarid ? onChange(item?.guarid) : onChange(item);

    setParams({
      guarreference: item?.guarreference,
      guarantorname: item.guarantorname,
      guarid: item?.guarid,
    });
    close();
  };

  return (
    <>
      <AppSearchInput
        onSearch={() => {
          open();
          localStorage.removeItem('searchParams');
          localStorage.removeItem('searchParams_components');
        }}
        value={
          <Typography.Link>
            {!value?.guarid
              ? Params?.guarid
                ? `${Params.guarreference ?? ''}  -  ${
                    Params.guarantorname ?? ''
                  }`
                : 'Select guaranty'
              : value?.guarid
              ? `${value.guarreference ?? ''}  -  ${value.guarantorname ?? ''}`
              : 'Select guaranty'}
          </Typography.Link>
        }
      />
      <GuarantySearchModal
        setGuaranty={handleSelect}
        visible={visible}
        onCancel={close}
      />
    </>
  );
};

export default GuarantySelect;
